"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionDeleteGlobalError = exports.actionAddGlobalError = void 0;
var _globalError = require("../selectors/globalError");
var _actionTypes = require("../actionTypes");
var _actions = require("../../globalErrorDialog/actions");
var actionDeleteGlobalError = exports.actionDeleteGlobalError = function actionDeleteGlobalError() {
  return function (dispatch, getState) {
    if ((0, _globalError.getErrors)(getState()).length === 1) {
      dispatch((0, _actions.actionHideGlobalErrorDialog)());
    }
    dispatch({
      type: _actionTypes.ACTION_DELETE_GLOBAL_ERROR
    });
  };
};

/**
 *
 * @param data: Object - arbitrary data
 */
var actionAddGlobalError = exports.actionAddGlobalError = function actionAddGlobalError(data) {
  return function (dispatch, getState) {
    var oldCurrentError = (0, _globalError.getCurrentError)(getState());
    dispatch({
      type: _actionTypes.ACTION_ADD_GLOBAL_ERROR,
      payload: {
        error: data
      }
    });
    if (!oldCurrentError) {
      dispatch((0, _actions.actionShowGlobalErrorDialog)());
    }
  };
};